"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Space = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Space = ({ size = 0, horizontal }) => {
    const style = {};
    if (horizontal) {
        style.display = 'inline-block';
        style.width = 12 + size * (size > 0 ? 4 : 2);
    }
    else {
        style.display = 'block';
        style.height = 12 + size * (size > 0 ? 4 : 2);
    }
    return React.createElement("span", { style: style });
};
exports.Space = Space;
